import { Component, Input } from '@angular/core';
import { ComponentType } from '@angular/cdk/portal';
import { MatDialog } from '@angular/material/dialog';
import { ResourceViewDialogData, getObjectProperty } from 'utils';
import {
  ArrayTableDialogData,
  CtxArrayTableComponent,
} from 'libs/ng-ui/src/lib/_components/array-table/array-table.component';
import { CtxButtonComponent } from '../../button/button.component';
import { MatTooltipModule } from '@angular/material/tooltip';

type PropertyViewDialogData = {
  /** Component to show resource in */
  component: ComponentType<any>;
} & ResourceViewDialogData;

@Component({
  selector: 'ctx-view-in-modal-button',
  templateUrl: './view-in-modal-button.component.html',
  standalone: true,
  imports: [MatTooltipModule, CtxButtonComponent],
})
export class ViewInModalButtonComponent {
  @Input() config: ArrayTableDialogData | PropertyViewDialogData;

  constructor(private dialog: MatDialog) {}

  get viewLabel() {
    return 'label' in this.config ? this.config.label : 'View';
  }

  launch() {
    if ('resource' in this.config && 'component' in this.config) {
      this.launchViewDialog(this.config);
    } else {
      this.launchArrayDialog(this.config);
    }
  }

  /** Shows the component set in the `config` in a Dialog */
  private launchViewDialog(config: PropertyViewDialogData) {
    this.dialog.open<any, ResourceViewDialogData>(config.component, {
      data: {
        resource: config.resource,
        title: config.title,
        property: config.property,
        type: config?.type,
      },
    });
  }

  /**
   * Shows a ctx-array-table for the displayType = array
   */
  private launchArrayDialog(config: ArrayTableDialogData) {
    this.dialog.open<any, ArrayTableDialogData>(CtxArrayTableComponent, {
      data: {
        title: config.title,
        arrayOfObjects: config.arrayOfObjects,
        columnsToDisplay: config.columnsToDisplay,
      },
    });
  }

  /** True if button is to be disabled */
  get disabled() {
    // IF ResourceViewDialog config
    if ('resource' in this.config && 'component' in this.config) {
      // we loading data after opening the modal
      if (this.config.type === 'entitlements') {
        return false;
      }
      if (this.config.property) {
        const value = getObjectProperty(
          this.config.resource,
          this.config.property
        );
        return (Array.isArray(value) && value.length === 0) || !value;
      } else {
        return false;
      }
      /** ELSE ArrayTableDialog config */
    } else {
      const _array = this.config.arrayOfObjects;
      return !(
        this.config.arrayOfObjects &&
        Array.isArray(_array) &&
        _array.length !== 0
      );
    }
  }
}
